module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": 'Test implémentation'
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "3"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "ID Transaction",
      "maxLength": 64
    },
    model: {
      value: (_vm.axepta.transId),
      callback: function($$v) {
        _vm.$set(_vm.axepta, "transId", $$v)
      },
      expression: "axepta.transId"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#007bff",
      "text-decoration": "underline"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": _vm.genTransId
    }
  }, [_vm._v("\n            Aléatoire\n          ")])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "3"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "ID Facture",
      "maxLength": 12
    },
    model: {
      value: (_vm.axepta.refNr),
      callback: function($$v) {
        _vm.$set(_vm.axepta, "refNr", $$v)
      },
      expression: "axepta.refNr"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#007bff",
      "text-decoration": "underline"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": _vm.genRefNr
    }
  }, [_vm._v("\n            Aléatoire\n          ")])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "2"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "Montant"
    },
    model: {
      value: (_vm.axepta.amount),
      callback: function($$v) {
        _vm.$set(_vm.axepta, "amount", $$v)
      },
      expression: "axepta.amount"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "1"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": "Devise",
      "inputType": "listeSelect"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.axepta.currency),
      expression: "axepta.currency"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.axepta, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "EUR"
    }
  }, [_vm._v("EUR")])])])], 1)], 1), _vm._v(" "), _c('b-form-radio-group', {
    attrs: {
      "id": "radioGroupPayment",
      "options": _vm.optionsPayment,
      "name": "radioGroupPayment"
    },
    model: {
      value: (_vm.selectedPayment),
      callback: function($$v) {
        _vm.selectedPayment = $$v
      },
      expression: "selectedPayment"
    }
  }), _vm._v(" "), (_vm.selectedPayment === _vm.optionsPayment[1]) ? _c('div', [_c('page-axepta', {
    attrs: {
      "refNr": _vm.axepta.refNr,
      "transId": _vm.axepta.transId,
      "amount": _vm.axepta.amount,
      "currency": _vm.axepta.currency,
      "orderDesc": _vm.axepta.orderDesc,
      "height": 700
    }
  })], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-81c4a482", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81c4a482","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/PaymentFromApplicationTestForm.vue
// module id = 2476
// module chunks = 2